const lightTooltipStyle = theme => ({
  lightTooltip: {
    background: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    color: theme.palette.text.primary,
    fontSize: 13,
    lineHeight: "25px",
    maxWidth: "unset",
    "& div": {
      display: "flex",
      justifyContent: "space-between",
    },
    "& b": {
      marginLeft: "10px",
    },
  },
  lightTooltipPopper: {
    opacity: 1,
  },
  tooltipContentWrapper: {
    display: "flex",
    "& > svg": {
      marginLeft: "5px",
    },
  },
});

export default lightTooltipStyle;



// WEBPACK FOOTER //
// ./src/assets/EnergyCompany/jss/lightTooltip.jsx